import { useEffect } from "react";
const useUrlSync = (conversationId) => {
  useEffect(() => {
    if (conversationId) {
      const params = new URLSearchParams(window.location.search);
      const currentConversationId = params.get("conversationId");
      if (currentConversationId !== conversationId) {
        params.set("conversationId", conversationId);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, "", newUrl);
      }
    }
  }, [conversationId]);
};
export {
  useUrlSync
};
//# sourceMappingURL=useUrlSync.js.map
